let styles = {
  proposalButton: {
    display: "flex",
  },
  tabs: {
    display: "flex",
    margin: "auto",
    padding: 0,
    backgroundColor: "rgb(FF,FF,FF)",
    justifyContent: "center",
    alignSelf: "center",
    overflow: "hidden",
    maxWidth: "1700px",
  },
};

export default styles;
